export const styles = {
  page: (theme) => ({
    minHeight: '92vh',
    padding: '28px clamp(16px, 5vw, 64px)',
    background: theme.colors.background,
  }),
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    flexWrap: 'wrap',
    marginBottom: 18,
  },
  title: (theme) => ({ margin: 0, fontSize: 26, fontWeight: 700, color: theme.colors.text }),
  subtitle: (theme) => ({
    margin: '6px 0 0',
    fontSize: 14,
    maxWidth: 560,
    color: theme.colors.text,
    opacity: 0.65,
  }),
  toolbar: { display: 'flex', gap: 10, flexWrap: 'wrap' },
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexWrap: 'wrap',
    marginBottom: 20,
  },

  defaultCallout: (theme) => ({
    borderRadius: 14,
    marginBottom: 18,
    border: `1px solid ${theme.colors.primary}`,
    background: `${theme.colors.primary}0d`,
  }),
  calloutInner: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
  },
  calloutIcon: (theme) => ({
    width: 42,
    height: 42,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#fff',
    background: theme.colors.primary,
  }),
  calloutBody: { flex: '1 1 280px', minWidth: 240 },
  calloutTitle: (theme) => ({
    fontSize: 15,
    fontWeight: 700,
    color: theme.colors.text,
    marginBottom: 3,
  }),
  calloutText: (theme) => ({
    fontSize: 13,
    color: theme.colors.text,
    opacity: 0.72,
    lineHeight: 1.45,
  }),

  configIntro: (theme) => ({
    margin: '0 0 16px',
    fontSize: 13.5,
    lineHeight: 1.5,
    color: theme.colors.text,
    opacity: 0.65,
  }),
  configCard: (theme, active) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: 14,
    borderRadius: 12,
    marginBottom: 10,
    background: theme.colors.background,
    border: `1px solid ${active ? `${theme.colors.primary}33` : 'rgba(0,0,0,0.06)'}`,
  }),
  configIcon: (theme, active) => ({
    width: 34,
    height: 34,
    borderRadius: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: active ? '#fff' : theme.colors.text,
    background: active ? theme.colors.primary : `${theme.colors.text}14`,
    opacity: active ? 1 : 0.55,
  }),
  configLabel: (theme) => ({ fontSize: 14, fontWeight: 600, color: theme.colors.text, marginBottom: 3 }),
  configDesc: (theme) => ({ fontSize: 12.5, lineHeight: 1.45, color: theme.colors.text, opacity: 0.65 }),
  costHint: (theme) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    marginTop: 4,
    padding: '10px 12px',
    borderRadius: 10,
    fontSize: 12.5,
    lineHeight: 1.5,
    color: theme.colors.text,
    background: `${theme.colors.primary}14`,
  }),
  costHintIcon: (theme) => ({
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#fff',
    background: theme.colors.primary,
  }),

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: 16,
  },
  templateCard: (theme, isProtected, isHidden) => ({
    borderRadius: 14,
    overflow: 'hidden',
    background: theme.colors.backgroundSecondary,
    border: `1px solid ${isProtected ? theme.colors.primary : 'rgba(0,0,0,0.06)'}`,
    boxShadow: isProtected
      ? `0 6px 20px ${theme.colors.primary}22`
      : '0 6px 20px rgba(0,0,0,0.06)',
    paddingBottom: 12,
    opacity: isHidden ? 0.72 : 1,
  }),
  hiddenBadge: (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    padding: '2px 7px',
    borderRadius: 20,
    color: theme.colors.text,
    background: 'rgba(0,0,0,0.09)',
    opacity: 0.75,
  }),
  templateHead: { display: 'flex', alignItems: 'center', gap: 12, padding: '14px 14px 8px' },
  templateNameRow: { display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 },
  protectedBadge: (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    padding: '2px 7px',
    borderRadius: 20,
    color: theme.colors.primary,
    background: `${theme.colors.primary}18`,
  }),
  templateIcon: (theme) => ({
    width: 34,
    height: 34,
    borderRadius: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    flexShrink: 0,
    background: theme.colors.primary,
  }),
  templateName: (theme) => ({
    fontSize: 15,
    fontWeight: 600,
    color: theme.colors.text,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  templateMeta: (theme) => ({ fontSize: 12, color: theme.colors.text, opacity: 0.6 }),

  statusRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '0 12px 10px' },
  statusDot: (color) => ({
    width: 9,
    height: 9,
    borderRadius: '50%',
    background: color === 'green' ? '#21ba45' : color === 'red' ? '#f5222d' : '#faad14',
    boxShadow: `0 0 0 3px ${
      color === 'green' ? 'rgba(33,186,69,0.15)' : color === 'red' ? 'rgba(245,34,45,0.15)' : 'rgba(250,173,20,0.15)'
    }`,
  }),
  statusLabel: (theme) => ({
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: theme.colors.text,
    opacity: 0.8,
  }),
  qualityChip: (theme) => ({
    marginLeft: 'auto',
    fontSize: 11,
    padding: '2px 8px',
    borderRadius: 20,
    background: theme.colors.background,
    color: theme.colors.text,
    opacity: 0.7,
  }),

  metaChips: { display: 'flex', flexWrap: 'wrap', gap: 6, padding: '12px 12px 0' },
  metaChip: (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    fontSize: 11,
    padding: '3px 8px',
    borderRadius: 6,
    background: theme.colors.background,
    color: theme.colors.text,
    opacity: 0.75,
  }),
  rejectReason: { margin: '10px 12px 0', fontSize: 12, color: '#f5222d' },
  pendingNotice: (theme, isProtected) => ({
    margin: '10px 12px 0',
    padding: '8px 10px',
    borderRadius: 8,
    fontSize: 12,
    lineHeight: 1.4,
    fontWeight: isProtected ? 600 : 400,
    color: isProtected ? theme.colors.primary : theme.colors.text,
    background: isProtected ? `${theme.colors.primary}14` : 'rgba(250,173,20,0.12)',
    opacity: isProtected ? 1 : 0.9,
  }),

  emptyCard: (theme) => ({ borderRadius: 12, background: theme.colors.backgroundSecondary, maxWidth: 620 }),
  emptyState: {
    padding: '40px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 14,
  },
  emptyText: (theme) => ({ margin: 0, maxWidth: 380, fontSize: 14, color: theme.colors.text, opacity: 0.7 }),

  // ---- modal (editor) ----
  modalBody: { display: 'flex', gap: 20, flexWrap: 'wrap', maxHeight: '68vh' },
  modalForm: {
    flex: '1 1 320px',
    minWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    overflowY: 'auto',
    paddingRight: 6,
  },
  modalPreview: (theme) => ({
    flex: '1 1 300px',
    minWidth: 280,
    background: theme.colors.background,
    borderRadius: 12,
    padding: 16,
    alignSelf: 'flex-start',
    position: 'sticky',
    top: 0,
  }),
  previewLabel: (theme) => ({
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: theme.colors.text,
    opacity: 0.55,
    marginBottom: 10,
  }),
  previewStats: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 12,
    color: theme.colors.text,
    opacity: 0.65,
  }),
  fieldLabel: (theme) => ({ fontSize: 13, fontWeight: 600, marginBottom: 6, color: theme.colors.text }),
  varTag: (theme) => ({
    cursor: 'pointer',
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    background: theme.colors.background,
    color: theme.colors.primary,
    fontWeight: 600,
  }),
  readonlyCard: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: '12px 14px',
    borderRadius: 10,
    background: theme.colors.background,
    color: theme.colors.text,
  }),
  readonlyMeta: (theme) => ({ fontSize: 12, color: theme.colors.text, opacity: 0.6 }),
  buttonEditor: (theme) => ({
    padding: 12,
    borderRadius: 10,
    background: theme.colors.background,
  }),
  buttonEditorHead: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
};
